import React from 'react';
import DormantIcon from '../assets/spark-icons/DormantIcon.svg';
import NaissantIcon from '../assets/spark-icons/NaissantIcon.svg';
import RayonnantIcon from '../assets/spark-icons/RayonnantIcon.svg';
import SolaireIcon from '../assets/spark-icons/SolaireIcon.svg';

export const getSparkStatus = (sparkAmount) => {
  if (sparkAmount == null || isNaN(sparkAmount)) {
    return { label: 'Dormant', icon: DormantIcon };
  }
  if (sparkAmount <= 5) return { label: 'Dormant', icon: DormantIcon };
  if (sparkAmount <= 20) return { label: 'Naissant', icon: NaissantIcon };
  if (sparkAmount <= 60) return { label: 'Rayonnant', icon: RayonnantIcon };
  return { label: 'Solaire', icon: SolaireIcon };
};